module.exports = __webpack_public_path__ + "static/img/reset_wifiLedStrip.f4c5c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/reset_wifiLedStrip.png
// module id = 262
// module chunks = 1